import React from 'react';
import styled from 'styled-components';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
// todo use federated CurrentSearchContextProvider
import { CurrentSearchContextProvider } from 'components/domain/currentSearch/CurrentSearchContext';
import { FdrMobileFiltersTotalCountContextProvider } from 'fdr/components/candidate/fdr-search-filters-controls/fdr-mobile-filters-total-count.context';
import { FdrWishlistCompareItemsContainer } from 'fdr/components/local/fdr-wishlist/fdr-wishlist-compare-items-container';
import FdrWishlistSearchControlForm from 'fdr/components/local/fdr-wishlist/fdr-wishlist-search-control-form';
import WishlistFiltersOverview from './WishlistFiltersOverview';
import { WishlistItemSelect } from './WishlistItemSelect';
import WishlistMobileFilters from './WishlistMobileFilters';
import WishlistSearchControlDesktopFormContainer from './WishlistSearchControlDesktopFormContainer';
import WishlistSearchControlFormActionToggler from './WishlistSearchControlFormActionToggler';

const MobileFiltersWrapper = styled.div(
  sx2CssThemeFn({
    py: 3,
    px: 3,
    mb: [3, null],
    backgroundColor: 'white',
  })
);

export const WishlistCompareViewContent: React.FC = () => {
  const { mobile } = useDeviceType();

  return (
    <>
      {!mobile ? (
        <FdrWishlistSearchControlForm>
          <WishlistSearchControlDesktopFormContainer />
        </FdrWishlistSearchControlForm>
      ) : (
        <CurrentSearchContextProvider>
          <FdrMobileFiltersTotalCountContextProvider>
            <WishlistSearchControlFormActionToggler />
            <MobileFiltersWrapper>
              <WishlistMobileFilters />
              <WishlistFiltersOverview />
            </MobileFiltersWrapper>
          </FdrMobileFiltersTotalCountContextProvider>
        </CurrentSearchContextProvider>
      )}
      <WishlistItemSelect />
      <FdrWishlistCompareItemsContainer />
    </>
  );
};
